import * as _ from "lodash";
import http from "../constant/api";

export const SessionService = {
  querySession: async (filter) => {
    const result = await http.get(`/api/session/query`, {
      params: filter,
    });

    return result;
  },
  addSession: async (data) => {
    const result = await http.post(`/api/session/add`, data);

    return result;
  },
  editSession: async (id, data) => {
    const result = await http.put(`/api/session/${id}/edit`, data);

    return result;
  },
  removeSession: async (id) => {
    const result = await http.delete(`/api/session/${id}/remove`);

    return result;
  },
  readSession: async (id) => {
    const result = await http.get(`/api/session/${id}/read`);

    return result;
  },
  countSessionWaiting: async () => {
    const result = await http.get(`/api/session/status/waiting/count`);

    return result;
  },
  readSessionByRequesterId: async (requesterId) => {
    const result = await http.get(
      `/api/session/requester-id/${requesterId}/read`
    );

    return result;
  },
  convertTicket: async (id, data) => {
    const result = await http.post(`/api/session/${id}/convert-ticket`, data);

    return result;
  },
  listSessionHistoryByRequester: async (requesterId) => {
    const result = await http.get(
      `/api/session/requester-id/${requesterId}/list/history`
    );

    return result;
  },
  reportChat: async (filter) => {
    const result = await http.get(`/api/session/report/chat`, {
      params: filter,
    });

    return result;
  },
  reportRating: async (filter) => {
    const result = await http.get(`/api/session/report/rating`, {
      params: filter,
    });

    return result;
  },
  reportStaff: async () => {
    const result = await http.get(`/api/session/report/staff`);

    return result;
  },
};
